import { createSlice } from "@reduxjs/toolkit";
import { Token } from "../interface/Token";

const initialState: Token | null = null;



const tokenAuthenticationTPSlice = createSlice({
  name: "tokenAuthenticationTP",
  initialState,
  reducers: {
    setTokenAuthenticationInStore: (state, action) => {
      return action.payload;
    }
  },
});

export const { setTokenAuthenticationInStore } = tokenAuthenticationTPSlice.actions;

export default tokenAuthenticationTPSlice.reducer;